import React, { useMemo } from "react";
import ThreeStateToggle from ".";
import { STATUS_IDS } from "../../../constants/common";
import { useTranslation } from "react-i18next";

interface VehicleAllowedThreeStateToggleProps {
  isVehicleAllowed?: boolean;
  setIsVehicleAllowed: React.Dispatch<
    React.SetStateAction<boolean | undefined>
  >;
}

const VehicleAllowedThreeStateToggle = ({
  isVehicleAllowed,
  setIsVehicleAllowed,
}: VehicleAllowedThreeStateToggleProps) => {
  const { t } = useTranslation();

  const threeStatesToggle = useMemo(
    () => [
      {
        id: 1,
        title: t("allowed"),
        value: STATUS_IDS.SELECTED,
      },
      {
        id: 2,
        title: t("reqInfoSelect"),
        value: STATUS_IDS.SELECT,
      },

      {
        id: 3,
        title: t("notAllowed"),
        value: STATUS_IDS.UN_SELECTED,
      },
    ],
    [t]
  );

  const handleToggle = (val: string) => {
    setIsVehicleAllowed(Number(val) === 1);
  };

  return (
    <div className="flex items-center gap-3">
      <p>{t("approveVehicleEntryPermit")}:</p>
      <ThreeStateToggle
        states={threeStatesToggle}
        value={
          isVehicleAllowed === undefined
            ? STATUS_IDS.SELECT
            : isVehicleAllowed
            ? STATUS_IDS.SELECTED
            : STATUS_IDS.UN_SELECTED
        }
        onChange={handleToggle}
      />
    </div>
  );
};

export default VehicleAllowedThreeStateToggle;
